<template>
  <div class="flex-center position-ref full-height">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <img src="/assets/logos/languagemate.png">
      <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      <SsoError v-if="error" :message="error"></SsoError>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import axios from "axios";
import CryptoJS from "crypto-js";

export default {
  name: "LanguageMate",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'Y11SwDifZUIu7.iQboREQwiVQzC_0k1KvBkFeCr5nK9K!e9Hr8XvscKmCK3PVR4zw',
      secretKey2: 'iHvfpr!ABEf8IdHu6v%HMjiPyiD9LKX4.0k8VdrjmzHLxnvpiy9+aG5YOjeWRW4',
      userData: null,
      userData2: null,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      this.loading = true
      // gelen data çözülüyor
      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser();
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('LanguageMate SSO:', message);
    },

    ueslmsCheckUser() {
      axios.post('https://www.ueslms.com/api/v2/languagemate/user/check', {user: this.userData})
      // axios.post('https://ueslms.test/api/v2/languagemate/user/check', {user: this.userData})
          .then(response => {
            if (response.data.success) {
              this.userData2 = response.data.user;
              this.goLanguageMate()
            } else if (response.data.message) {
              // success:false + message → örn. lisans/yetki reddi. Kullanıcı henüz
              // yok diye create'e düşmek yerine reddi doğrudan gösteriyoruz, çünkü
              // create de aynı kontrolden geçip aynı sebeple reddedilecek.
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      axios.post('https://www.ueslms.com/api/v2/languagemate/user/create', this.userData)
      // axios.post('https://ueslms.test/api/v2/languagemate/user/create', this.userData)
          .then(response => {
            if (response.data.success) {
              this.userData2 = response.data.user;
              this.goLanguageMate()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    async goLanguageMate() {
      // console.log('this.userData2', this.userData2)
      const studentData = {
        school_id: parseInt(this.userData2.campus_id, 10), // school
        campus_id: parseInt(this.userData2.campus_id, 10),
        campus_name: this.userData2.campus_name,
        user_id: parseInt(this.userData2.user_id, 10), // ueslms'ten dönen sonuçtan alınıyor
        first_name: this.userData2.first_name,
        last_name: this.userData2.last_name,
        username: this.userData2.username,
        role_type: this.userData2.role_type,
        class: this.userData2.class,
        country: "Turkey",
        start_date: "2025-08-30 00:00:00",
        end_date: "2026-08-15 23:59:59"
      }

      console.log('studentData', studentData);
      const textJson = JSON.stringify(studentData);
      const uriText = decodeURIComponent(textJson);
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.secretKey2).toString();
      // console.log(ciphertext);
      location.href = "https://LanguageMate.io/sso/ues?token=" + btoa(ciphertext);
    },

  }
}
</script>
